import { createContext } from 'react';

export interface DcrRowDraft {
  approveFareAmount: string;
  transportTypeId: number | undefined;
}

export interface DcrDraftsState {
  drafts: Record<number, DcrRowDraft>;
  onDraftChange: (recordId: number, patch: Partial<DcrRowDraft>) => void;
}

export interface DerDraftsState {
  drafts: Record<number, string>;
  onDraftChange: (detailId: number, approveAmount: string) => void;
}

const ignoreDraftChange = () => undefined;

export const DcrDraftsContext = createContext<DcrDraftsState>({
  drafts: {},
  onDraftChange: ignoreDraftChange,
});

export const DerDraftsContext = createContext<DerDraftsState>({
  drafts: {},
  onDraftChange: ignoreDraftChange,
});
